/**
 * tr/en/ru dışındaki dil kodları için i18n’e İngilizce şablonunu kopyalar;
 * CMS addResourceBundle ile gelen metinler üzerine yazılır.
 */
import i18n from '../../i18n/core.js'
import { ensureLocalesLoaded } from '../../i18n/ensureLocalesLoaded.js'

const BUNDLED_LANGS = new Set(['tr', 'en', 'ru'])

/**
 * @param {string} targetCode — örn. de, pt-br
 */
export async function seedI18nLanguageIfNeeded(targetCode) {
  const code = String(targetCode ?? '')
    .trim()
    .toLowerCase()
  if (!code || BUNDLED_LANGS.has(code)) return

  await ensureLocalesLoaded('en')

  const template = 'en'
  const nss = Array.isArray(i18n.options.ns) ? i18n.options.ns : []
  for (const ns of nss) {
    const bundle = i18n.getResourceBundle(template, ns)
    if (bundle && typeof bundle === 'object' && Object.keys(bundle).length > 0) {
      i18n.addResourceBundle(code, ns, JSON.parse(JSON.stringify(bundle)), true, true)
    }
  }
}
